
(function() {
  var module = {};
  var result = {};
  module.exports = { "pt-br": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m", "days": "{{ days }} dias", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Fev", "march": "Mar", "april": "Abr", "may": "Maio", "june": "Jun", "july": "Jul", "august": "Ago", "september": "Set", "october": "Out", "november": "Nov", "december": "Dez" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "pt-br": "static-7.446"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.446",
    "da": "static-7.446",
    "de": "static-7.446",
    "el": "static-7.446",
    "en": "static-7.446",
    "es-mx": "static-7.446",
    "es": "static-7.446",
    "fi": "static-7.446",
    "fr": "static-7.446",
    "it": "static-7.446",
    "ja": "static-7.446",
    "ko": "static-7.446",
    "nl": "static-7.446",
    "no": "static-7.446",
    "pl": "static-7.446",
    "pt-br": "static-7.446",
    "sv": "static-7.446",
    "zh-cn": "static-7.446",
    "zh-hk": "static-7.446"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pt-br', {version: 'static-7.446'}); }
})();


